export const discountType = {
  PERCENTAGE: 'percentage',
  FIXED: 'fixed',
};

